import { render } from "./sepVegas.vue?vue&type=template&id=41db802a"
import script from "./sepVegas.vue?vue&type=script&lang=js"
export * from "./sepVegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__